import Vue from 'vue'
import VueApollo from 'vue-apollo'
import apollo from '@/packages/apollo-client'

Vue.use(VueApollo)

export default new VueApollo({
	defaultClient: apollo
})
